import { useEffect } from 'react';
import { Outlet, useNavigate, useMatch } from 'react-router-dom';
import { IconLoader, PermissionDenied, PermissionEnum } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import {
  useLazyGetAccountsEmployeeQuery,
  useLazyGetAccountsSettingsQuery,
} from '../../store/dictionaries/services';

import ROUTES from '../../routes';

const Accounts = (): React.JSX.Element => {
  const navigate = useNavigate();

  const match = useMatch(ROUTES.ACCOUNTS);

  const dispatch = useAppDispatch();

  const { currentEmployee, overdraftEnabled } = useAppSelector(
    (state) => state.accountsDictionaries,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  const [getAccountsEmployee] = useLazyGetAccountsEmployeeQuery();
  const [getAccountsSettings] = useLazyGetAccountsSettingsQuery();

  useEffect(() => {
    if (!currentEmployee) {
      getAccountsEmployee();
    }

    if (overdraftEnabled === undefined || overdraftEnabled === null) {
      getAccountsSettings();
    }
  }, [dispatch, currentEmployee, overdraftEnabled]);

  useEffect(() => {
    let title = 'Accounts';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  useEffect(() => {
    if (match && activePermissions?.includes(PermissionEnum.SECTION_ACCOUNTS)) {
      navigate(ROUTES.ACCOUNTS_LIST);
    }
  }, [match, activePermissions]);

  let content = (
    <div>
      <IconLoader />
    </div>
  );

  if (
    activePermissions &&
    !activePermissions?.includes(PermissionEnum.SECTION_ACCOUNTS)
  ) {
    content = <PermissionDenied />;
  } else if (
    activePermissions &&
    activePermissions?.includes(PermissionEnum.SECTION_ACCOUNTS)
  ) {
    content = <Outlet />;
  }

  return content;
};

export default Accounts;
